export default "/_next/static/images/498ef25e484b4f334ca786d057b79cef.jpg";